export default {

    OPEN_TRACKING_QUERY_DIALOG : 'OPEN_TRACKING_QUERY_DIALOG',
    CLOSE_TRACKING_QUERY_DIALOG: 'CLOSE_TRACKING_QUERY_DIALOG'

};
